export const CREATE_USER_SETTING = "setting/CREATE_USER_SETTING";
export const CREATE_USER_SETTING_SUCCESS = "setting/CREATE_USER_SETTING_SUCCESS";
export const CREATE_USER_SETTING_ERROR = "setting/CREATE_USER_SETTING_ERROR";
export const GET_USER_SETTINGS = "setting/GET_USER_SETTINGS";
export const GET_USER_SETTINGS_SUCCESS = "setting/GET_USER_SETTINGS_SUCCESS";
export const GET_USER_SETTINGS_ERROR = "setting/GET_USER_SETTINGS_SUCCESS";